<template>
  <div class="container">
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2 class="mr-5">
          {{ $t('taghistorypage.title') }}
        </h2>
      </template>
    </Toolbar>

    <control-table
      v-model:rows="controlFilter.pageable.size"
      v-model:filters="controlFilter.filters"
      v-model:sortField="controlFilter.pageable.sortField"
      v-model:sortOrder="controlFilter.pageable.sortOrder"
      paginator-position="both"
      :paginator="true"
      :value="controls"
      :total-records="totalControlCount"
      @filter="getControls"
      @sort="getControls"
      @page="onPageChange($event)"
    >
      <template #before>
        <Column
          field="lineId"
          :header="$t('entity.lineId.requestId')"
          :sortable="true"
          :show-filter-menu="false"
          class="col-tab"
          style="width:200px"
        >
          <template #body="{ data }">
            <router-link :to="{name: 'lineIdDetail', params: {id: data.lineId.id}}">
              {{ data.lineId.requestId }}
            </router-link>
          </template>
        </Column>
      </template>
    </control-table>
  </div>
</template>

<script>
import Toolbar from "primevue/toolbar";
import ControlTable from "@/components/control/ControlTable";
import Column from "primevue/column";
import {reactive} from "vue";
import useControlFilter from "@/composables/filters/useControlFilter";

export default {
  name: 'UserTagHistoryView',
  components: {
    ControlTable,
    Toolbar,
    Column
  },
  setup(){
    const controlFilter = reactive(useControlFilter());
    controlFilter.pageable.sortField = "barcodeRange.start";
    controlFilter.filters.deleted.value = false;

    return {
      controlFilter
    };
  },
  data() {
    return {
      controls: [],
      totalControlCount: 0,
    }
  },
  mounted() {
    this.controlFilter.filters.userId.value = this.$store.state.auth.user.id;
    this.getControls();
  },
  methods: {
    async getControls() {
      const result = await this.$controlService.getAll(this.controlFilter.getQueryParams());
      this.controls = result.content;
      this.totalControlCount = result.totalItemsCount;
    },
    async onPageChange(event) {
      this.pageable.page = event.page;
      await this.getControls();
    },
  }
}
</script>
